import createClient from 'openapi-fetch'

import { paths } from './types'

export const meshingClient = createClient<paths>({
  baseUrl: '/meshing',
  credentials: 'include',
  headers: {
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
})
